// 统一方法
import request from '@/utils/axios.tool';
// 图片上传
export const uploadFile = (data)=>{              
    return request.post(`/api/uploadFile`,data)
}